import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showSendConsultNowInvitationModal } from 'actions/modal';
import { displayGlobalMessage } from 'actions/globalMessage';
import { createVidyoRoomAuthTicket, setVidyoRoomIdForCN } from '../../../../actions/waitingArea';

const centerPanelCallerJoined = (props) => {
  const dispatch = useDispatch();
  const [gettingTicket, setGettingTicket] = useState(false);

  let withoutIcon = 'ui button left-text color-button color-button-hover color-white mrlnull mrbnull mrtm';

  // This function is to fetch callscreen auth ticket for SP to join the Conasult Now.
  // Keep this function for now in case we will use interval
  // But this function is not called because clicking "Open Call" button will open fake callscreen window anyway, regardless of whetehr caller has joined or not
  const getAuthTicketToJoin = (roomId) => {
    let cbGetAuthTicket = (result, callScreenAuthTicket) => {
      setGettingTicket(false);
      dispatch(showSendConsultNowInvitationModal(false));
      dispatch(setVidyoRoomIdForCN(null));

      if (result) {
        let callscreenUrl = window.APP.CONFIGURATION.CALLSCREEN_LOCATION + '#/?authticket=' + callScreenAuthTicket;

        callscreenUrl += '&video=' + (!!props.waitingArea.providerCallConfig.isCameraOn).toString().toLowerCase();
        callscreenUrl += '&audio=' + (!!props.waitingArea.providerCallConfig.isMicrophoneOn).toString().toLowerCase();

        window.open(
          callscreenUrl,
          null,
          'width=' +
            (screen.width - 20) +
            ',height=' +
            (screen.height - 100) +
            ', left=0, top=0, scrollbars=yes,status=yes'
        );
      } else {
        console.error('No Auth Ticket was created');
        // TODO-HH - Check if the message is OKAY
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ServerErrors.GeneralApiError,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
          })
        );
        return;
      }
    };
    setGettingTicket(true);
    dispatch(createVidyoRoomAuthTicket(props.waitingArea.id, roomId, cbGetAuthTicket));
  };

  return (
    <div className="ui form mrbl pdtsss">
      <>
        <div className="title-sms mrtm">
          <span>{APP.LANGUAGE.SendConsultNowInvitation.JoinedSuccessCallInfo1}</span>
        </div>
        <button
          tabIndex="1"
          type="button"
          className={withoutIcon + ' no-icon-btn'}
          onClick={(e) => getAuthTicketToJoin(props.isCallerJoined)}
        >
          {APP.LANGUAGE.SendConsultNowInvitation.OpenCall}
        </button>
      </>
    </div>
  );
};

export default centerPanelCallerJoined;
